// Import model
import { StartObjectAppointmentInitiateOmwsmsRequest } from '../models/StartObjectAppointmentInitiateOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentInitiateOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentInitiateOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentInitiateOmwsmsRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentInitiateOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentInitiateOmwsmsRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentInitiateOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentInitiateOmwsmsRequest');
    }


    const instance: StartObjectAppointmentInitiateOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentInitiateOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentInitiateOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentInitiateOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentInitiateOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentInitiateOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentInitiateOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentInitiateOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentInitiateOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
